import styled from 'styled-components';

const FontSize16Div = styled.div`
  color: #173c51;
  font-size: 16px;
  font-weight: 400;
`;

export default FontSize16Div;
